module.exports = __webpack_public_path__ + "img/EMPERADOR-03.fbed9186.png";